import React from 'react';

import Table, { HeadsType, RowType } from '../../Shared/CustomTable';
import { FILTER_KEYS, HEADERS, MESSAGES } from '../../../config/constants';
import { text_truncate, fixDecimals, minsToTime } from '../../../helpers/helpers';

import 'react-accessible-accordion/dist/fancy-example.css';
import { useRouter } from '../../../helpers/customHooks';
import { useDataEventsState, useFiltersState } from '../../../store/hooks';
import { PerformanceRoutes } from './types';
import Loader from 'components/Shared/Loader';

type Headers = {
  [key: string]: any
} // TODO:REMOVE WHEN ADDED TS TO COMMONS FILE

const MetricByPeriodView = () => {

  const { data } = useDataEventsState();
  const { history, params, forcedScopeForFilter: scopeForFilter } = useRouter<PerformanceRoutes>();

  const { view, metric } = params;
  const showNegative = (params.metric === 'biasedBalanceLoad' || params.metric === 'maxSustDecel');
  const { players:playerData, playersSessions, highlights } = data;
  const fullMetric = (HEADERS as Headers)[metric] || {};
  const title = fullMetric.LABEL && fullMetric.LABEL[view === 'condensed' ? 'LIVE' : 'ALL'];
  const {
    [FILTER_KEYS.POSITIONS]: positionSelected
    } = useFiltersState(scopeForFilter, FILTER_KEYS.POSITIONS);
  const headerFields: string[] = [];
  if (highlights && highlights.sessionInfo) {
    const sessionData = highlights.sessionInfo;
    Object.keys(sessionData).forEach(index => {
      headerFields.push(sessionData[index].name);
    });
  }
  const headers: HeadsType<string> = [
    { style: { width: '33px' }, isPinFlagCell: true, isSelectable: true, isColumnFixedY: true },
    { style: { width: '120px', textAlign: 'left' }, content: 'PLAYER', isOrderly: true, isColumnFixedY: true },
    { style: { width: '48px' }, content: 'NO.', isOrderly: true, isColumnFixedY: true },
    { class: 't-ll', style: { width: '78px' }, content: 'POS.', isOrderly: true, isColumnFixedY: true },
    ...(headerFields.map((content, index) => {
      return {
        class: index === headerFields.length - 1 ? 't-ll' : '',
        content: content,
        print: (content: string) => text_truncate(content, 20),
        style: { width: '75px' },
        isOrderly: true
      };
    }))
  ];

  const rows: RowType[] = [];
  let positionFilter: any;
  const cellPrint = (content: number) =>
    <label
      style={{
        // width: fullMetric.FORMAT === 'time' ? '50px' : '39px',
        textOverflow: 'ellipsis', overflow: 'hidden'
      }}
    >
      {fullMetric.FORMAT === 'time' ? minsToTime(content) : fixDecimals(content, fullMetric.FORMAT as number)}
    </label>;

  if (playerData) {
    if(positionSelected && positionSelected.length > 0){
      positionFilter = positionSelected.map(obj => obj.value);
    }
    const players = positionSelected && positionSelected.length > 0? playerData.filter(player => positionFilter.includes(player.position) ) 
    : playerData;

    players.forEach(player => {
      let i = 0;
      player.metricsByPeriod = playersSessions && playersSessions[player.id] ? headerFields.map(session => {
        let value = 0;
        if (playersSessions[player.id] && playersSessions[player.id][i] && session === playersSessions[player.id][i].sessionName) {
          value = playersSessions[player.id][i][(HEADERS as Headers)[metric]?.FULLPRACTICE_KEY] as number;
          i++;
        }
        return value;
      }) : [];
      rows.push({
        id: player.id,
        columns: [
          { isPinFlagCell: true },
          {
            style: { fontWeight: 'bold', textAlign: 'left' },
            content: player.name,
            print: content => {
              return (
                <div
                  style={{
                    width: '100px',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden'
                  }}
                >
                  {content}
                </div>
              );
            }
          },
          { content: player.jerseyNumber, print: content => <label>{'#' + content}</label> },
          { class: 't-ll', content: player.position },
          ...(player.metricsByPeriod.map((metric:number, index:number) => {
            return {
              class: index === player?.metricsByPeriod!.length - 1 ? 't-ll' : '',
              content: isNaN(+metric)?-100000: +metric,
              title: metric,
              print: (content: number) => showNegative? cellPrint(content) : content < 0?"-":cellPrint(content),
              order: (contentA: number, contentB: number) => {
                return contentA - contentB;
              }
            };
          }))
        ]
      });
    });
  }

  return (
    <>
      <div className="header-p">
        {history.length > 2 && // if opened in new tab, no back button is rendered on first screen.
        <div
          onClick={() => history.goBack()}
          style={{
            padding: '12px 18px',
            opacity: '0.6',
            cursor: 'pointer'
          }}
        >
          <div className="link-arrow-left">
            <img src="/assets/images/sprites/left.svg" alt="" height="13px" className="logo" />
          </div>
        </div>}
        <div className="p-l-t">
          <h4 className="title-byPeriod" style={{ color: '#333D47' }}>{title} by Period</h4>
        </div>
      </div>
      <div
        className="practice-body"
        style={{ height: 'calc(100vh - 240px)', border: 0 }}
      >
        <Loader forceMessage={rows.length === 0? MESSAGES.EMPTY : ''}>
        <Table
          headers={headers}
          rows={rows}
          isPinnedStyle
          hasHeadersTooltip
          default={{ orderColumn: -3 }}
        />
        </Loader>
      </div>
    </>
  );
};
export default MetricByPeriodView;
